import {
  Add,
  Article,
  Circle,
  ContentCopy,
  Download,
  Edit,
  PlayArrow,
  Replay,
  Stop,
  TextSnippet,
} from "@mui/icons-material";

export type MappedIcons =
  | "Add"
  | "Replay"
  | "Edit"
  | "Download"
  | "Duplicate"
  | "Start"
  | "Stop"
  | "Tail"
  | "Logs"
  | "Default";

export const IconFactory = {
  getIcon(iconName: MappedIcons, onClick?: () => void) {
    switch (iconName) {
      case "Add":
        return <Add onClick={onClick} />;
      case "Replay":
        return <Replay onClick={onClick} />;
      case "Edit":
        return <Edit onClick={onClick} />;
      case "Download":
        return <Download onClick={onClick} />;
      case "Start":
        return <PlayArrow onClick={onClick} />;
      case "Stop":
        return <Stop onClick={onClick} />;
      case "Tail":
        return <TextSnippet onClick={onClick} />;
      case "Logs":
        return <Article onClick={onClick} />;
      case "Duplicate":
        return <ContentCopy onClick={onClick} />;
      default:
        return <Circle onClick={onClick} />;
    }
  },
};
